import { createApp } from 'vue'
import { converToCamelCase } from './util'
import Components from '@/core/components'
import Store from '@/store'
import filters from '@/core/filters'
import { VueSvgIconPlugin } from '@yzfe/vue3-svgicon'
import VeeValidateComponents from '@/core/validation'

export class View {
  
  views = [];

  constructor() {
    this.views = [];
  }

  find(name) {
    const views = this.views.filter((view) => view && view.name === name);
    return views.length === 1;
  }

  register(name, component) {
    if (!name || typeof name !== "string" || !component) {
      return;
    }

    name = name.toLowerCase();
    if (this.find(name)) {
      return;
    }

    this.views.push({
      name,
      component
    });
  }

  render( el ) {
    try {
      if (!el) {
        return;
      }

      const viewElements = document.getElementsByTagName("view");
      if (!viewElements || viewElements.length <= 0) {
        return;
      }

      const parentElement = viewElements.item(0);
      const viewName = (parentElement.getAttribute("name") || "").toLowerCase();
      if (!viewName) {
        return;
      }

      // Loop to see if the name of the view is a valid component
      let vueComponent = null;
      this.views.forEach(view => {
        if (view && view.name && viewName === view.name) {
          vueComponent = view.component;
        }
      });
      
      // No Vue Component to render so stop
      if (!vueComponent) {
        return;
      }

      // Build any data properties to send to the component
      const props = {};
      for (let attr of parentElement.attributes) {
        if ( attr.name.startsWith("data-prop-") ) {
          const name = converToCamelCase(attr.name.replace("data-prop-", ""));
          if (attr.value && ["{","["].includes(attr.value.substring(0,1))) {
            try {
              props[name] = JSON.parse(attr.value)
            } catch (err) {
              console.error(`Unable to convert data property ${attr.name}`, err)
              props[name] = attr.value;
            }
          } else if (attr.value && !isNaN(attr.value)) {
            props[name] = parseFloat(attr.value);
          } else if (attr.value && ["true", "false"].includes(attr.value)) {
            props[name] = (attr.value === "true");
          } else {
            props[name] = attr.value;
          }
        }
      }

      // Create the Vue Component to get it ready to mount to the DOM
      const instance = createApp(vueComponent, props)

      // register filters
      instance.config.globalProperties.$filters = filters

      instance.use(Store)
      instance.use(VueSvgIconPlugin, { tagName: 'svgicon' })

      // register components
      Components.forEach(c => instance.component(c.name, c.component))
      VeeValidateComponents.forEach(c => instance.component(c.name, c.component))

      // get the element the new app should mount to
      let $rootElement = $("#app-container .inner")
      let $viewWrapper = $("<div id='viewwrapper'></div>")
      $viewWrapper.append(parentElement)
      $rootElement.append($viewWrapper)

      instance.mount($viewWrapper[0])

      // remove the wrapper
      $viewWrapper.find(".page").unwrap()

    } catch (e) {
      console.error(`Unable to load view`, e);
    }
  }

}
